export class MultiplyPlaceOrderWrapperItem {
    constructor(orderId, orderEditBase) {
        this.orderId = null;
        this.orderEditBase = null;
        this.orderId = orderId;
        this.orderEditBase = orderEditBase;
    }
}
